module.exports = __webpack_public_path__ + "media/images/icons/flags/CD-66777da60232ba1547748fc8df56860c.svg";